export const purple = "#524763"
export const teal = "#a2d8d8"
export const accent = `#72b100`

export const social = {
  twitter: "#000aced",
  facebook: "#3b5998",
}
